import { HttpApiClient } from 'effect/http-api';
import { Context, Layer } from 'effect';
import { ApiHttpApiContract } from './api-contract';

export class ApiClient extends Context.Service<
  ApiClient,
  HttpApiClient.ForApi<typeof ApiHttpApiContract>
>()('@listening/api-contract/ApiClient') {
  /**
   * The typed client over the `HttpClient` the runtime provides. Without a
   * `baseUrl`, requests are relative, which a browser resolves against its
   * own origin.
   */
  static readonly layer = (
    options?: Parameters<typeof HttpApiClient.make>[1],
  ) => Layer.effect(this, HttpApiClient.make(ApiHttpApiContract, options));
}
